export const environment = {
  production: false,
  apiUrl: "https://staging.pedics-labs.com",
  stripePublicKey: "pk_test_b6hBdpNJGo5cHFEGdVxL39W3"
};
